import React from 'react';
import IconWrapper from '../../../IconWrapper';
const InputValidIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { fillRule: "evenodd", d: "m12.416 4.277-5.672 8.508-3.098-3.098.708-.707 2.235 2.235 4.995-7.492.832.554Z" })));
export default InputValidIconSmall;
//# sourceMappingURL=InputValidIconSmall.js.map